import { httpClient } from "@services/api/httpClient";

export async function getOfferStatistics() {
  const response = await httpClient.get("/offer/statistics");
  return response.data;
}